import paperPluginBannerSrc from 'assets/images/home-paper-plugin-banner.png';
import {t} from 'i18next';
import {ReactNode} from 'react';

import {logStrategyMapBannerClick} from './dashboardAnalytics';
import {useTileImpressionRef} from './HomeVisitContext';
import styles from './MapBanner.module.css';

const PAPER_PLUGIN_BANNER_URL = 'https://dropbox.slack.com/archives/C0ARFB71TNG/p1793289761807399';

/**
 * Banner row above the tile grid. `columns` is the grid's current column count
 * and `bannerCols` the banner's span; `companion` fills the remaining column at
 * the banner's height.
 */
export const MapBannerRow = ({
  columns,
  bannerCols,
  companion,
}: {
  columns: number;
  bannerCols: number;
  companion?: ReactNode;
}) => {
  const impressionRef = useTileImpressionRef('strategyMapBanner');
  return (
    <div className={styles.row} style={{gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`}}>
      <a
        ref={impressionRef}
        href={PAPER_PLUGIN_BANNER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.banner}
        style={{gridColumn: `span ${bannerCols}`}}
        aria-label={t('dashboard_banner_aria_label')}
        onClick={logStrategyMapBannerClick}
      >
        <img className={styles.media} src={paperPluginBannerSrc} alt="" />
        <span className={styles.hoverOverlay} aria-hidden>
          <span className={styles.hoverChip}>{t('dashboard_banner_hover_text')}</span>
        </span>
      </a>
      {companion && <div className={styles.companion}>{companion}</div>}
    </div>
  );
};
